/**
 * @generated SignedSource<<b0981676389694ee441aeedbf62d18ac>>
 * @relayHash 06360d2bbaec11fabf37e9a939e4deb2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 140235c4f5635e73615326edc00e7662870ea84fa76f18b7c55d808da8d4e566

import type { ConcreteRequest } from 'relay-runtime';
export type RedirectPlanPageWithoutScenarioIdPreloadQuery$variables = {
  planId: string;
};
export type RedirectPlanPageWithoutScenarioIdPreloadQuery$data = {
  readonly jira: {
    readonly planById: {
      readonly defaultNavigationItem: {
        readonly url?: string | null;
      };
    } | null;
  } | null;
};
export type RedirectPlanPageWithoutScenarioIdPreloadQuery = {
  response: RedirectPlanPageWithoutScenarioIdPreloadQuery$data;
  variables: RedirectPlanPageWithoutScenarioIdPreloadQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "planId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "planId"
  }
],
v2 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "url"
    }
  ],
  "type": "JiraNavigationItem",
  "abstractKey": "__isJiraNavigationItem"
},
v3 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "RedirectPlanPageWithoutScenarioIdPreloadQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraPlan",
            "kind": "LinkedField",
            "name": "planById",
            "plural": false,
            "selections": [
              {
                "kind": "RequiredField",
                "field": {
                  "kind": "LinkedField",
                  "name": "defaultNavigationItem",
                  "plural": false,
                  "selections": [
                    (v2/*: any*/)
                  ]
                },
                "action": "THROW"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RedirectPlanPageWithoutScenarioIdPreloadQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraPlan",
            "kind": "LinkedField",
            "name": "planById",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "defaultNavigationItem",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  (v2/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v3/*: any*/)
                    ],
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ]
              },
              (v3/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "140235c4f5635e73615326edc00e7662870ea84fa76f18b7c55d808da8d4e566",
    "metadata": {},
    "name": "RedirectPlanPageWithoutScenarioIdPreloadQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "83805307401c6ff4c137637ba3624e80";

export default node;
